import Vue from 'vue'
import Vuex from 'vuex'
import VueSession from 'vue-session'
import auth from './modules/auth'
import clients from './modules/clients'
import files from './modules/files'
import definitions from './modules/definitions'
import alfakodos from './modules/alfakodos'
import targettimes from './modules/targettimes'
import jumblewords from './modules/jumblewords'
import session from './modules/session'

Vue.use(Vuex)
Vue.use(VueSession)

export default new Vuex.Store({
  modules: {
    auth,
    clients,
    files,
    definitions,
    alfakodos,
    targettimes,
    jumblewords,
    session
  },
  actions: {
    reload() {
      this.dispatch('session/fetch')
      this.dispatch('clients/fetch')
      this.dispatch('targettimes/fetch')
      this.dispatch('alfakodos/fetch')
      this.dispatch('jumblewords/fetch')
      this.dispatch('files/fetch')
      this.dispatch('definitions/fetch')
    }
  }
})
